export default __webpack_public_path__ + "./images/bn.1fad01e6.png";